import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';

export class InstallationsperiodeHeizungWarmwasser extends BaseModel {
    // properties
    id: number | null = null;
    bezeichnung: string | null = null;
    kuerzel: string | null = null;

    getClassName(): string {
        return 'InstallationsperiodeHeizungWarmwasser';
    }
}

export class InstallationsperiodeHeizungWarmwasserCollection extends BaseCollection<InstallationsperiodeHeizungWarmwasser> {
    protected modelCls = InstallationsperiodeHeizungWarmwasser;

    public getModelClassName(): string {
        return 'InstallationsperiodeHeizungWarmwasser';
    }
}

let _globalInstallationsperiodeHeizungWarmwasserCollection: InstallationsperiodeHeizungWarmwasserCollection | null = null;

/**
 * global (single instance) collection: To be used where a global, shared instance can be used.
 * Note that this collection MUST NOT be filered / ordered on other places, as it is a shared instance!
 * @returns
 */
export function globalInstallationsperiodeHeizungWarmwasserCollection(): InstallationsperiodeHeizungWarmwasserCollection {
    if (!_globalInstallationsperiodeHeizungWarmwasserCollection) {
        _globalInstallationsperiodeHeizungWarmwasserCollection = new InstallationsperiodeHeizungWarmwasserCollection();
        _globalInstallationsperiodeHeizungWarmwasserCollection.setQueryParams({
            sort: [
                {
                    property: 'reihenfolge',
                    direction: 'asc',
                },
            ],
        });
        _globalInstallationsperiodeHeizungWarmwasserCollection.query();
    }
    return _globalInstallationsperiodeHeizungWarmwasserCollection;
}
